import React, { useRef, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, TextField } from '@material-ui/core';
import { Tooltip, Divider } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { renderDate } from 'common/services/util';

const useStyles = makeStyles(theme => ({
    divider: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    divObs: {
        height: '200px',
        overflow: 'scroll',
        backgroundColor: '#eeeeee',
        border: '1px solid lightgrey'
    },
    message: {
        display: 'flex',
        backgroundColor: 'white',
        alignItems: 'center',
        margin: '5px',
        padding: '5px',
        paddingLeft: '10px',
        borderRadius: '10px'
    },
    messageTextAndDate: {
        display: 'flex',
        flexDirection: 'column',
        flex: 3
    }
}));

const CardTextChat = ({ title, observations, addObservation, deleteObservation, messageType }) => {
    const classes = useStyles();
    const [message, setMessage] = useState("")
    const [openTooltipCopy, setOpenTooltipCopy] = useState(false);

    const inputMessageRef = useRef(null)
    const buttonMessageRef = useRef(null)

    useEffect(() => {
        inputMessageRef.current.addEventListener('keyup', event => {
            if (event.key === 'Enter' && event.target.value !== "") {
                event.preventDefault()
                buttonMessageRef.current.click()
            }
        })
    })

    const copyAllMessages = () => {
        const textToCopy = observations.map(message => message.message).join('\n')
        navigator.clipboard.writeText(textToCopy);
        setOpenTooltipCopy(true)
        setTimeout(() => setOpenTooltipCopy(false), 800)
    }

    const handleChange = event => {
        setMessage(event.target.value)
    };

    const handleAddObservation = () => {
        addObservation(message, messageType);
        setMessage('')
    }

    const observationsRender = () => {
        if (!observations)
            return 
            
        return (<div>
            {observations.map(({ message, date, id }) => (
                <div className={classes.message} key={id || date}>
                    <div className={classes.messageTextAndDate}>
                        <div style={{whiteSpace: 'pre-wrap', marginBottom: '5px'}}>{ message }</div>
                        <span style={{fontSize: '11px'}}>{ renderDate(date) }</span>
                    </div>
                    <div>
                        <IconButton onClick={() => deleteObservation({ message, date, id}, messageType)}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                </div>
            ))}
        </div>)
    };

    return (
        <Card>
            <CardHeader 
                title={title}
                action={
                    <IconButton onClick={copyAllMessages}>
                        <Tooltip title='Copiado!' open={openTooltipCopy}>
                            <FileCopyIcon />
                        </Tooltip>
                    </IconButton>
                } 
            />
            <Divider className={classes.divider}></Divider>
            <CardContent className={classes.contentCardObs}>
                <div className={classes.divObs}>
                    {observationsRender()}
                </div>
                <TextField
                    margin="dense"
                    id="name"
                    label="Nuevo mensaje"
                    type="email"
                    fullWidth
                    inputRef={inputMessageRef}
                    value={message}
                    onChange={handleChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="start">
                                <IconButton
                                    edge="end"
                                    aria-label="toggle password visibility"
                                    buttonRef={buttonMessageRef}
                                    disabled={message === ''}
                                    onClick={handleAddObservation}>
                                    <SendIcon disabled={message === ''} color='primary' />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </CardContent>
        </Card>
    )
}

export default CardTextChat